import React, { createContext, useCallback, useContext, useState } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter } from './ReconcileUIHelpers';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

const ReconcileUIContext = createContext()

export function useReconcileUIContext() {
	return useContext(ReconcileUIContext)
}

export function ReconcileUIProvider({ reconcileUIEvents, children }) {
	const { currentState } = useSelector(
		(state) => ({ currentState: state.auth.user }),
		shallowEqual,
	);
	if (currentState.role === "SuperAdmin" || currentState.role === "SuperDuperAdmin" || currentState.role === "KepalaCabang") {
	} else {
		initialFilter.filter.branch = currentState.channel.branch_uuid
	}

	// console.log(currentState.channel.branch_uuid)

	const [queryParams, setQueryParamsBase] = useState(initialFilter);
	// if (currentState) {

	// }
	const setQueryParams = useCallback((nextQueryParams) => {
		setQueryParamsBase((prevQueryParams) => {
			if (isFunction(nextQueryParams)) {
				nextQueryParams = nextQueryParams(prevQueryParams);
			}

			if (isEqual(prevQueryParams, nextQueryParams)) {
				return prevQueryParams;
			}

			return nextQueryParams;
		});
	}, []);


	const value = {
		queryParams,
		setQueryParamsBase,
		setQueryParams,
		newReconcileClick: reconcileUIEvents.newReconcileClick,
		openEditReconcilePage: reconcileUIEvents.openEditReconcilePage,
		openChooseReconcilePage: reconcileUIEvents.openChooseReconcilePage
	};

	return (
		<ReconcileUIContext.Provider value={value}>
			{children}
		</ReconcileUIContext.Provider>
	);
}
